module.exports = __webpack_public_path__ + "img/3.7a36e104.png";